{
  "planningDocument": "Plandokument",
  "assignment": {
    "title": "Oppgavetittel",
    "startEndTime": "Start- og sluttid",
    "startTime": "Starttid",
    "publishWindow": "Publiseringsvindu",
    "publishTime": "Publiseringstid",
    "createPrintArticle": "Opprett printartikkel",
    "convertToArticle": "Planlegg som artikkel",
    "convertToTimeless": "Lagre som tidløs",
    "removeAssignment": "Vil du fjerne oppdraget",
    "chooseTime": "Velg tid",
    "timeFromTo": "Tid fra-to",
    "actions": {
      "addAssignment": "Legg til oppdrag",
      "addAssignee": "Legg til oppdragstaker"
    },
    "collaboration": {
      "inProgress": "Ny oppdrag opprettes av",
      "overtake": "Ta over"
    }
  },
  "description": {
    "internal": "Intern beskjed",
    "public": "Beskrivelse"
  },
  "actions": {
    "openPlanning": "Åpne plan",
    "open": "Åpne",
    "assignments": "Oppdrag",
    "noDeliverables": "Ingen leveranser"
  },
  "prompts": {
    "slugMissing": "Stikkord mangler",
    "slugMissingDescription": "Vennligst legg til en stikkord i oppgaven. Etter det kan du lage en tekst.",
    "createPrompt": "Vil du opprette en {{documentLabel}} for oppdraget{{title}}?"
  },
  "move": {
    "pickPlanning": "Velg plan",
    "label": "Flytte",
    "dateSwitch": "Endre dato på plan",
    "dateSwitchDescription": "Planen og alle tekstoppdragen endrer dato til",
    "dateSwitchAssignments": "Velg nedenfor om bilde- og videooppdrag også skal endre datoer.",
    "assignmentCreateInfo": "Hvis du ikke velger en timeplan, vil en ny timeplan med denne oppgaven bli opprettet for deg på den valgte datoen.",
    "assignmentAddInfo": "Denne oppgaven vil bli lagt til i den valgte planen.",
    "assignmentMoveSuccess": "Oppdraget er flyttet",
    "moveAssignment": "Flytte oppdrag",
    "moveAssignmentConfirm": "Er du sikker på at du vil flytte oppgaven?",
    "showOlder": "Vis eldre"
  },
  "related": {
    "relatedEvents": "Hendelse"
  },
  "slugline": "Legg til stikkord",
  "story": "Legg til story",
  "title": "Plantittel",
  "yourNewType": "Dine sist opprettede {{type, lowercase}}",
  "preview": "Forhåndsvisning"
}
